<div
  class="grid grid-cols-3 gap-4 md:grid-cols-6 md:gap-0 bg-white rounded w-full py-6 items-center justify-center mt-1">
  <app-mb-stat-box *ngFor="let child of citizenStatsData; let last = last" [number]="child.number" [name]="child.name"
    [last]="last" class=""></app-mb-stat-box>
</div>

<div class="bg-white rounded" *transloco="let t">
  <div class="bg-white rounded mt-3 pt-6 px-3 sm:px-6">
    <div
      class="flex flex-col gap-3 border-b pb-6 border-b-mbaza-gray-light md:flex-row md:items-center md:justify-between">
      <div class="flex flex-col gap-2 md:flex-row md:items-center md:gap-4 min-w-0 md:flex-1">
        <span class="font-black uppercase text-sm shrink-0">{{ t('citizens') }} ({{ totalItems }})</span>
        <app-mb-search (searchSubmit)="onSearch()" (clearSearch)="onClearSearch()" [(searchValue)]="searchValue"
          placeholder="{{ t('searchHere') }}" [width]="'w-full md:w-2xs'" class="w-full md:flex-none min-w-0" />
      </div>
      <app-mb-button label="{{t('newCitizen')}}" (click)="citizenModal.showModal()" class="w-full md:w-auto shrink-0"
        type="secondary" />
    </div>
  </div>

  <app-mb-modal #citizenModal [(isVisible)]="isCitizenModalVisible" [title]="t('newCitizen')"
    [okText]="t('createCitizen')" [okLoading]="newCitizenForm.isSubmitting" (OkActionHandler)="onCitizenModalOkAction()"
    (CancelActionHandler)="onCitizenModalCancelAction()">
    <app-new-citizen-form #newCitizenForm (citizenCreated)="onCitizenCreated()" />
  </app-mb-modal>
  @if (isLoadingCitizens) {
  <app-mb-skeleton />
  } @else if (citizensError) {
  <div class="flex items-center justify-center h-32 px-8">
    <div class="text-center">
      <p class="text-red-500 mb-2">{{ citizensError }}</p>
      <app-mb-button label="t('retry')" type="secondary" (click)="loadCitizens(currentPage, pageSize, searchValue)"
        class="text-sm" />
    </div>
  </div>
  } @else {
  <div class="w-full overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]">
    <nz-table #citizenTable nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]="false"
      [nzData]="listOfCitizens"
      class="w-full min-w-[640px] px-3 sm:px-6 h-[calc(80vh-100px)]">
      <tbody>
        <tr
          class="cursor-pointer hover:bg-gray-50 border-b border-b-mbaza-gray-light transition-colors flex justify-between w-full relative"
          *ngFor="let citizen of listOfCitizens; let i = index" (click)="navigateToCitizenDetail(citizen.id)"
          (keydown.enter)="navigateToCitizenDetail(citizen.id)" tabindex="0">
          <td class="sticky left-0 z-10 w-[5rem] font-semibold bg-white">
            {{ ((currentPage - 1) * pageSize) + i + 1 }}
          </td>
          <td class="w-[15rem] font-semibold text-mbaza-text-primary">
            {{ citizen.fullName }}
          </td>
          <td class="w-[12rem] text-mbaza-gray">
            {{ citizen.phoneNumber }}
          </td>
          <td class="w-[14rem] text-mbaza-gray">
            {{ t('numberOfCases') }}:
            <span class="text-black underline ml-1">{{ citizen.caseCount }}</span>
          </td>
          <td class="w-[12rem] text-mbaza-gray">
            {{ citizen?.createdAt | date : 'dd MMM yyyy' }}
          </td>
          <td class="sticky right-0 z-50 w-[5rem] px-2 bg-white">
            <div class="flex justify-end items-center h-full">
              <img [src]="ASSET_CONSTANTS.I_more_vertical" alt="arrow right" class="w-5 h-5 grayscale" />
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  }
  <nz-pagination [nzPageIndex]="currentPage" [nzTotal]="totalItems" [nzPageSize]="pageSize"
    *ngIf="totalItems > pageSize" (nzPageIndexChange)="onPageChange($event)"
    style="padding: 20px; text-align: right"></nz-pagination>
</div>
